"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormManual = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var FormManual = function (_a) {
    var livestream = _a.livestream, setLivestream = _a.setLivestream;
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Forms.Input, { name: 'livestream_id', value: livestream.livestream_id, placeholder: 'Livestream ID', onChange: function (livestream_id) { return setLivestream({ livestream_id: livestream_id }); } })),
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Forms.Input, { name: 'ingest', value: livestream.ingest, placeholder: 'Ingest', onChange: function (ingest) { return setLivestream({ ingest: ingest }); } })),
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Forms.Input, { name: 'ingest_name', value: livestream.ingest_name, placeholder: 'Ingest Key', onChange: function (ingest_name) { return setLivestream({ ingest_name: ingest_name }); } })));
};
exports.FormManual = FormManual;
exports.FormManual.propTypes = {
    /**
     * The Livestream
     */
    livestream: prop_types_1.default.shape({
        title: prop_types_1.default.string,
        description: prop_types_1.default.string,
        category_id: prop_types_1.default.oneOfType([
            prop_types_1.default.number,
            prop_types_1.default.string,
        ]),
        video: prop_types_1.default.object,
    }),
    /**
     * Set the Livestream
     */
    setLivestream: prop_types_1.default.func,
    /**
     * The Categories
     */
    categories: prop_types_1.default.object,
};
exports.FormManual.defaultProps = {};
